import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { MGMemberEntity } from './mgmember.entity'

export class MGMembersRepository extends BaseRepository<MGMemberEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'mgm', token, cache)
    }
}
